<template>
  <nav class="level mt-3 is-mobile">
    <div class="level-left">
      <a class="level-item" @click.prevent="replyToTweet" title="Reply to this tweet in a new thread">
        <b-icon icon="reply"></b-icon>
        <span class="ml-2">{{ tweet.quote_count }}</span>
      </a>
      <a class="level-item" @click.prevent="quoteRetweet" title="Quote retweet this tweet in a new thread">
        <b-icon icon="comment"></b-icon>
        <b-icon icon="retweet"></b-icon>
      </a>
    </div>
    <div class="level-right">
      <a :class="['level-item', tweet.retweeted ? 'has-text-success' : 'has-text-grey']" @click.prevent="retweet" title="Retweet this tweet">
        <b-icon icon="retweet"></b-icon>
        <span class="ml-2">{{ tweet.retweet_count }}</span>
      </a>
      <a :class="['level-item', tweet.favorited ? 'has-text-success' : 'has-text-grey']" @click.prevent="favorite" title="Like this tweet">
        <b-icon icon="heart"></b-icon>
        <span class="ml-2">{{ tweet.favorite_count }}</span>
      </a>
    </div>
  </nav>
</template>

<script>
import tweets from "../../api/tweets";

export default {
  name: "TweetActions",
  props: ['tweet'],
  methods: {
    replyToTweet() {
      if (!this.$store.getters.activeThreadUntouched) {
        this.$store.dispatch('createNewThread')
      }
      this.$store.commit('setReplyTo', this.tweet)
      this.$router.push({path: '/app/compose'})
      this.$store.dispatch('focusOnTweet', 0)
    },
    quoteRetweet() {
      if (!this.$store.getters.activeThreadUntouched) {
        this.$store.dispatch('createNewThread')
      }
      this.$store.commit('setQuoteTweet', {
        index: 0,
        data: this.tweet
      })
      this.$router.push({path: '/app/compose'})
      this.$store.dispatch('focusOnTweet', 0)
    },
    favorite() {
      if (this.tweet.favorited) {
        tweets.favoriteDestroy(this.tweet.id).then(() => {
          this.tweet.favorited = false
          this.tweet.favorite_count -= 1
        })

      } else {
        tweets.favoriteCreate(this.tweet.id).then(() => {
          this.tweet.favorited = true
          this.tweet.favorite_count += 1
        })
      }
    },
    retweet() {
      if (this.tweet.retweeted) {
        tweets.retweetDestroy(this.tweet.id).then(() => {
          this.tweet.retweeted = false
          this.tweet.retweet_count -= 1
        })

      } else {
        tweets.retweetCreate(this.tweet.id).then(() => {
          this.tweet.retweeted = true
          this.tweet.retweet_count += 1
        })
      }
    }
  }
}
</script>

<style scoped>

nav .level-item {
  min-width: 50px;
}

</style>
